import React from 'react'
import classnames from 'classnames'
import { connect } from 'react-redux'
import '@/assets/styles/components/order-confirm-status.scss'
import { getSafe } from '@/helpers/global';
import icon_success from '@/assets/images/icons/icon_success.png'
import icon_fail from '@/assets/images/icons/icon_fail.png'
import trade_icon_amend from '@/assets/images/icons/trade_icon_amend_normal.png'
import trade_icon_cancel from '@/assets/images/icons/trade_icon_cancel_normal.png'
import { openOrderCancelDialog, openOrderJournalDetailDialog, openOrderModifyDialog } from '@/actions/app';
import { formatFunctions } from '../../helpers/functions';
import { dataType } from '@/constants/data-type'
import { ORDER_MODE, REFRESH_DATA } from '@/constants/app';
import { SERVICES_RESP } from '@/configurations';
import { orderActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { ORDER_FILTER_STATUS } from '@/constants/filter-type'
import Tips from '../Tips/Tips';
import { tipsType } from '@/constants/tips-type';
import { COMPANY_SUPPORTS } from '@/constants/companys';

class OrderConfirmStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderInformation: [],
      failReason: '',
      status: '-',
      errMsgList:[],
      orderFeesDetailed:[]
    }
  }

  render() {
    const { language, orderResult, mode, isCancel} = this.props
    const { orderInformation, failReason, status, errMsgList, orderFeesDetailed} = this.state
    const isSuccess = orderResult.isSuccess === 'Y'
    return (
      <React.Fragment>
        <div className="order-confirm-status-box" style={isSuccess ? { paddingTop:'26px' } : { paddingTop:'0' }}>
          <header>
            {isSuccess
              ? <div className={classnames('c-status c-status-success')}>
                <img src={icon_success} alt="icon_success" />{getSafe(() => language.order_confirm_received_instruction)}
              </div>
              : 
              <React.Fragment> 
              <div className={classnames('c-status c-status-fail')}>
                <img src={icon_fail} alt="icon_fail" />{getSafe(() => language.order_failed)}
              </div>
              {
                errMsgList && errMsgList .length > 0 && errMsgList.map((item,index)=> <Tips key={index} type={tipsType.error}>{item}</Tips>)
              }
              </React.Fragment>
              }
            {isSuccess && <div className="c-reference-no">
              <span>{getSafe(() => language.common_order_id)}</span>
              <span>{orderResult.orderGroupID}</span>
            </div>}
          </header>
          <section>
            {orderInformation.map(item =>
              <div key={item.label} className={classnames("order-information-item", item.classStyle)}>
                <label>{item.label}</label>
                <span>{item.value}</span>
              </div>
            )}
          </section>
          {isSuccess && isCancel !== 'Y' && <span style={{lineHeight:'40px'}}>{getSafe(() => language.common_commission_fees)}</span>}
          {isSuccess && isCancel !== 'Y' && <section>{orderFeesDetailed}</section>}
          {mode === ORDER_MODE.CREATE && isSuccess && <div className="note">
            <div className="note-order-status">
              {getSafe(() => language.order_confirm_status)} :  {iTradeEnv.company === COMPANY_SUPPORTS.SCB ? language[this.getStatusLabel(status.toLowerCase())] :
                language[`order_status_${status.toLowerCase()}`]}
            </div>
            <div className="note-content">
              {getSafe(() => language.order_confirm_note)}
            </div>
          </div>
          }
          {isSuccess
            ? <footer>
              <div className="action-right">
                {mode !== ORDER_MODE.CANCEL &&
                  <React.Fragment>
                    {/* <button onClick={this.handleAmend}><img src={trade_icon_amend} alt="trade icon amend" />{getSafe(() => language.common_modify)}</button>
                    <button onClick={this.handleCancel}><img src={trade_icon_cancel} alt="icon_success" />{getSafe(() => language.common_cancel)}</button> */}
                  </React.Fragment>}
                <button className="info" onClick={this.handleOpenDetail}>{language.order_journal_detail_title}</button>
              </div>
              {/* <button className={classnames("confirm-btn", "confirm")} onClick={() => this.props.onClose()}>
                {getSafe(() => language.common_confirm)}
              </button> */}
            </footer>
            : <footer>
              <div className="action-right">
                {/* {
                  errMsgList && errMsgList .length > 0 && errMsgList.map((item,index)=> <><Tips key={index} type={tipsType.error}>{item}</Tips><br/></>)
                } */}
              </div>
              <button className={classnames("confirm-btn", "confirm")} onClick={() => this.props.onClose(false)}>
                {getSafe(() => language.order_trade_again)}
              </button>
            </footer>
          }
        </div>
      </React.Fragment>
    )
  }

  getStatusLabel = (status) => {
    let key = ''
    for (let i = 0; i < ORDER_FILTER_STATUS.length; i++) {
      if (ORDER_FILTER_STATUS[i].value.includes(status)) {
        key = ORDER_FILTER_STATUS[i].label
      }
    }
    return key
  }

  handleAmend = () => {
    this.props.onClose()
    openOrderModifyDialog(this.props.orderResult)
  }

  handleCancel = () => {
    this.props.onClose()
    openOrderCancelDialog(this.props.orderResult)
  }

  handleOpenDetail = () => {
    this.props.onClose()
    openOrderJournalDetailDialog(this.props.orderResult,null, false, true, false);
  }

  computeOrderInformation(orderData, orderResult) {
    const { language, currentTradingAccount, mode, instrumentInfo } = this.props;
    let orderInformation;
    const isSuccess = orderResult.isSuccess === 'Y';
    const orderType = orderData.orderType.value ? orderData.orderType.value : orderData.orderType;
    let quantity = orderData.quantity !== undefined ? orderData.quantity : orderData.qty;
    const isBuy = orderData.isBuy ? orderData.isBuy : orderResult.bs === 'B';
    if (mode === ORDER_MODE.MODIFY) {
      quantity = orderResult.newQty
    }
    let price = orderData.price;
    if (mode === ORDER_MODE.MODIFY) {
      price = orderResult.newPrice
    }
    let name = ''
    // if(language.title === 'zh_TW' || language.title === 'zh_CN'){
    //   if(orderData.instrumentChineseShortName){
    //     name = orderData.instrumentChineseShortName
    //   }else{
    //     name = orderData.instrumentShortName
    //   }
    // }else{
    //   name = orderData.instrumentShortName
    // }
    if(language.title === 'zh_TW' || language.title === 'zh_CN'){
      if(orderData.instrumentChineseName){
        name = orderData.instrumentChineseName
      }else{
        name = orderData.instrumentName
      }
    }else{
      name = orderData.instrumentName
    }
    const goodTillDate = orderResult.goodTillDate ? orderResult.goodTillDate : orderData.goodTillDate;
    const stopType = getSafe(() => orderData.stopType.value, orderData.stopOrderType);
    const stopPrice = orderData.stopPrice;
    if (isSuccess) {
      orderInformation = [
        { label: language.place_order_dialog_cash_account, value: currentTradingAccount.clientID },
        {
          label: language.common_order_direction,
          value: language[`${isBuy ? 'common_buy' : 'common_sell'}`],
          classStyle: `${isBuy ? 'order-direction-buy' : 'order-direction-sell'}`
        },
        { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] },
        { label: language.common_order_time, value: formatFunctions.dataFormat(orderResult.inputTime, dataType.LONG_DATE) },
        { label: language.common_symbol, value: `${orderData.marketID}.${orderData.instrumentID}` },
        { label: language.common_currency, value: getSafe(() => orderData.currencyID, '') },
        { label: language.common_name, value: name },
        {
          label: language.common_good_till_date,
          value: goodTillDate ? formatFunctions.dataFormat(goodTillDate, dataType.SHORT_DATE) : '-'
        },
        {
          label: language.common_price,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(price, dataType.CURRENCY)}`
        },
        {
          label: language.common_quantity,
          value: `${formatFunctions.dataFormat(quantity, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && quantity > 1) ? 's' : '')}`
        },
        {
          label: language.common_trigger_type,
          value: getSafe(() => language[`order_stop_price_type_${stopType}`], '-')
        },
        {
          label: language.common_trigger_price,
          value: stopPrice
            ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(stopPrice, dataType.CURRENCY)}`
            : '-'
        },
        {
          label: language.common_commission_fees,
          value: orderResult.feeAmt + '' ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(orderResult.feeAmt, dataType.CASH)}` : '-'
        },
        {
          label: language.common_gross_amount,
          value: orderResult.holdAmount + '' ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(orderResult.holdAmount, dataType.CASH)}` : '-'
        },
      ]
    } else {
      orderInformation = [
        { label: language.place_order_dialog_cash_account, value: currentTradingAccount.clientID },
        { label: language.common_order_type, value: language[`order_type_${orderType.toLowerCase()}`] },
        { label: language.common_symbol, value: `${orderData.marketID}.${orderData.instrumentID}` },
        {
          label: language.common_order_direction,
          value: language[`${isBuy ? 'common_buy' : 'common_sell'}`],
          classStyle: `${isBuy ? 'order-direction-buy' : 'order-direction-sell'}`
        },
        { label: language.common_name, value: name },
        { label: language.common_good_till_date, value: goodTillDate ? goodTillDate.value : '-' },
        {
          label: language.common_price,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(price, dataType.CURRENCY)}`
        },
        {
          label: language.common_quantity,
          value: `${formatFunctions.dataFormat(quantity, dataType.NUMBER)} ${language.common_share.format((language.lang === 'en_US' && quantity > 1) ? 's' : '')}`
        },
        {
          label: language.common_trigger_type,
          value: getSafe(() => language[`order_stop_price_type_${stopType}`], '-')
        },
        {
          label: language.common_trigger_price,
          value: stopPrice
            ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(stopPrice, dataType.CURRENCY)}`
            : '-'
        },
        {
          label: language.common_commission_fees,
          value: orderResult.feeAmt + '' ? `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(orderResult.feeAmt, dataType.CASH)}` : '-'
        },
        {
          label: language.common_gross_amount,
          value: `${getSafe(() => orderData.currencyID, '')} ${formatFunctions.dataFormat(price * quantity, dataType.CASH)}`
        },
      ]
      if (orderResult.errorCode !== SERVICES_RESP.SUCCESS_CODE) {
        let errMsg;
        if (orderResult.errorCode === SERVICES_RESP.QTY_ERROR_CODE) {
          errMsg = orderResult.returnMessage
        } else {
          errMsg = orderResult.errorMessage
        }
        const reasonsList = orderResult.reasonsList;
        let reasons = [];
        for (let i = 0; i < reasonsList.length; i++) {
          const item = reasonsList[i];
          if(item.action === 'R'){
            reasons.push(item.reason);
          }else{
            // reason.splice(0,reason.length);
            break;
          }
        }
        this.setState({ failReason: errMsg , errMsgList: reasons})
      } else {
        this.setState({ failReason: '' })
      }
    }
    this.props.toggleRefreshTable(true)
    this.setState({ orderInformation })
  }

  getOrderStatus() {
    const { currentTradingAccount, language, orderResult } = this.props
    if (currentTradingAccount.clientID) {
      const params = {
        [PARAMS.CLIENT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: currentTradingAccount.clientID,
        [PARAMS.TRADING_ACCOUNT_SEQ]: currentTradingAccount.tradingAccSeq,
        [PARAMS.ORDER_GROUP_ID]: orderResult.orderGroupID,
        [PARAMS.LANGUAGE]: language.lang
      }

      this.props.getOrderDetail(params, res => {
        if (res.status === SERVICES_RESP.STATUS_OK) {
          if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
            const orderData = res.result.orderInfoList.length > 0 ? res.result.orderInfoList[0] : '';
            this.setState({ status: orderData.status ? orderData.status : '-' });
          }
        }
      })
    }
  }

  getOrderFees(){
    const {language,currentTradingAccount, orderResult} = this.props; 
    const {feesList} = orderResult;
    if(feesList){
      this.getOrderFeesDetailed(feesList);
    }else{
      const {clientID, tradingAccSeq} = currentTradingAccount;
      const {marketID, instrumentID, bs, newPrice, newQty} = orderResult;
      const params = {
        [PARAMS.CLIENT_ID]: clientID,
        [PARAMS.TRADING_ACCOUNT_ID]: clientID,
        [PARAMS.TRADING_ACC_SEQ]: String(tradingAccSeq),
        [PARAMS.LANGUAGE]: language.lang,
        [PARAMS.MARKET_ID]:marketID,
        [PARAMS.INSTRUMENT_ID]:instrumentID,
        [PARAMS.BS]:bs,
        [PARAMS.PRICE]: String(newPrice),
        [PARAMS.QTY]:String(newQty)
      }
      this.props.getOrderFeesAction(params, res => {
        if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
          this.getOrderFeesDetailed(res.result.feesList);
        }
      })
    }
  }

  getOrderFeesDetailed(feesList){
    const {language,orderData, orderResult} = this.props; 
    let orderFeesDetailed = [];
    feesList.map((item,index) => {
      const languageKey = `common_${item.feeName.toLowerCase().replace(' ','_')}`
      orderFeesDetailed.push(
          <div className={classnames('order-information-item')} key={index}>
              <span>{language[languageKey] ? language[languageKey] :item.feeName}</span>
              <span>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(item.amount)}</span>
          </div>
      )
    })
    orderFeesDetailed.push(
        <div className={classnames('order-information-item')} key={feesList.length}>
            <span>{language.common_fees_total_amount}</span>
            <span style={{color: '#1996e3'}}>{orderData.currencyID}&nbsp;{this.orderFeesFormatNumber(orderResult.feeAmt)}</span>
        </div>
    )
    this.setState({
      orderFeesDetailed:orderFeesDetailed
    })
  }

  orderFeesFormatNumber = (amount) => {
    let decimalCount = 2, decimal = ".", thousands = ",";
    amount = parseFloat(amount);
    if (!amount || isNaN(amount) || (amount == '')) {
      amount = 0;
    }
    if (amount === 0) {
      return amount;
    }
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 3 : decimalCount;
    const negativeSign = amount < 0 ? "-" : "";
    let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
    let j = (i.length > 3) ? i.length % 3 : 0;
    return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
  }

  componentDidMount() {
    this.getOrderStatus()
    this.computeOrderInformation(this.props.orderData, this.props.orderResult);
    this.getOrderFees();
  }
}

OrderConfirmStatus.defaultProps = {
  mode: ''
}

export default connect(
  state => ({
    language: state.app.language,
    currentTradingAccount: state.trade.currentTradingAccount,
    instrumentInfo: state.trade.instrumentInfo
  }),
  dispatch => ({
    toggleRefreshTable: (p) => dispatch({
      type: REFRESH_DATA.ORDER_TABLE,
      value: p
    }),
    getOrderDetail: (p, c) => dispatch(orderActions.getOrderDetailAction(p, c)),
    getOrderFeesAction: (p, res) => dispatch(orderActions.getOrderFeesAction(p, res))
  })
)(OrderConfirmStatus)